export default "/img/CC.bd6840c8658114b5cceff0ed3a403d85.png";